import React from "react";
import "./SheetTabs.css";

/**
 * SheetTabs
 * Bottom tab bar — one button per sheet name.  The active sheet is
 * highlighted; clicking another tab calls `onSelect(name)`.
 *
 * The click handler BLURS the tab button: otherwise focus rests on the
 * button and the in-cell editor's keydown handler treated the next
 * keystroke as aimed at a form control, so typing right after switching
 * sheets did nothing (QA #7).
 *
 * Sheet tabs are read-only for readers: they can switch sheets but can NOT
 * rename sheets or add new ones (QA). There is intentionally no rename
 * input, double-click handler or "+" (new sheet) button here.
 */
function SheetTabs({ sheetNames, activeSheet, onSelect }) {
  return (
    <div className="simple-excel-sheetbar">
      <div className="simple-excel-tabs" role="tablist" aria-label="Sheets">
        {sheetNames.map((name) => (
          <button
            key={name}
            type="button"
            role="tab"
            aria-selected={activeSheet === name}
            className={`simple-excel-tab ${activeSheet === name ? "active" : ""}`}
            onClick={(e) => {
              // Return focus to the grid so typing/shortcuts keep working.
              e.currentTarget.blur();
              onSelect(name);
            }}
            title={name}
          >
            {name}
          </button>
        ))}
      </div>
    </div>
  );
}

export default React.memo(SheetTabs);
